import { fetch } from '@maxtropy/components';

export interface IotProtocol {
  id: number;
  name: string;
}

export const getProtocol = () => fetch<Array<IotProtocol>>(`/api/iotProtocol/list`);
